import { IOrderMeasurementUnit } from 'interfaces';

export const calculateTotalOfUnits = (uoms: IOrderMeasurementUnit[]) => (
  uoms.reduce((acc, val) => (val.contains ? +val.quantity * +val.contains : +val.quantity) + acc, 0)
);
